import {makeStyles, IconButton, Tooltip} from "@material-ui/core";
import XLSXDownloadBtn from '../../../../atoms/creator/analyzeXlsxDownBtn';
import {useStylesTooltip} from "../../../../../config/theme";
import {useSelector} from "react-redux";

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    right: 0
  },
  iconBtn: {
    width: 40,
    borderRadius: 10,
    background: 'transparent'
  },
}));

const CompareHeader = (props: any) => {

  const classes = useStyles();
  const tooltipClasses = useStylesTooltip();
  const { compareMode, onCompareModeChange } = props;
  const { cliped } = useSelector((state: any) => state.analysis);

  return (
    <div className={classes.root}>
      <Tooltip classes={tooltipClasses} title="Table View" placement="bottom" arrow>
        <IconButton
          className={classes.iconBtn}
          size='small'
          style={{ marginRight: 8 }}
          onClick={() => onCompareModeChange(1)}
        >
          <img src={compareMode === 1 ? '/assets/icons/compare/icon_bullet_blue.svg' : '/assets/icons/compare/icon_bullet_gray.svg'} alt='img' />
        </IconButton>
      </Tooltip>

      <Tooltip classes={tooltipClasses} title="Chart View" placement="bottom" arrow>
        <IconButton
          className={classes.iconBtn}
          size='small'
          style={{ marginRight: 8 }}
          onClick={() => onCompareModeChange(2)}
        >
          <img src={compareMode === 2 ? '/assets/icons/compare/icon_board_blue.svg' : '/assets/icons/compare/icon_board_gray.svg'} alt='img' />
        </IconButton>
      </Tooltip>

      <XLSXDownloadBtn clipped={cliped} />
    </div>
  )
};

export default CompareHeader;